import { FC, useContext } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { MainContext } from 'contexts/MainContext';
import { imgUs } from 'constants/generic';

interface ButtonsLangProps {
  onClickLoad: (lang: string) => void;
  loading: string;
  activeLanguage?: string;
}

const langBtnClass = (code: string, loading: string, activeLanguage?: string) =>
  'btn btn-default btn-xsm' +
  (loading === code ? ' btn-pulse btn-disabled' : '') +
  (activeLanguage === code ? ' btn-active-blue' : '');

export const ButtonsLang: FC<ButtonsLangProps> = ({ onClickLoad, loading, activeLanguage }) => {
  const { initSiteData } = useContext(MainContext);
  const showHe = !['IT', 'ES', 'GR'].includes(initSiteData?.other?.defaultNationality || '');

  return (
    <div className="buttons-lang flex-row mt-5 mb-5">
      <button
        onClick={() => onClickLoad('en')}
        className={langBtnClass('en', loading, activeLanguage)}
      >
        <img src={imgUs} alt="US" className="mr-3" style={{ width: 14 }} />
        EN
      </button>
      <button
        onClick={() => onClickLoad('it')}
        className={langBtnClass('it', loading, activeLanguage)}
      >
        <ReactCountryFlag svg countryCode="it" className="mr-3" style={{ width: 14 }} />
        IT
      </button>
      <button
        onClick={() => onClickLoad('es')}
        className={langBtnClass('es', loading, activeLanguage)}
      >
        <ReactCountryFlag svg countryCode="es" className="mr-3" style={{ width: 14 }} />
        ES
      </button>
      {showHe && (
        <button
          onClick={() => onClickLoad('he')}
          className={langBtnClass('he', loading, activeLanguage)}
        >
          <ReactCountryFlag svg countryCode="IL" className="mr-3" style={{ width: 14 }} />
          HE
        </button>
      )}
      <button
        onClick={() => onClickLoad('fr')}
        className={langBtnClass('fr', loading, activeLanguage)}
      >
        <ReactCountryFlag svg countryCode="fr" className="mr-3" style={{ width: 14 }} />
        FR
      </button>
      <button
        onClick={() => onClickLoad('ru')}
        className={langBtnClass('ru', loading, activeLanguage)}
      >
        <ReactCountryFlag svg countryCode="ru" className="mr-3" style={{ width: 14 }} />
        RU
      </button>
    </div>
  );
};

export default ButtonsLang;
